import { apiFetch } from '@app/utils/utils';
import { AdminUserSummary, AdminUserDetail } from '@app/Users/types';

const BASE = '/api/admin/users';

export async function getUsers(opts: {
  q?: string;
  role?: string;
  limit?: number;
  offset?: number;
} = {}): Promise<AdminUserSummary[]> {
  const params = new URLSearchParams();
  if (opts.q) params.set('q', opts.q);
  if (opts.role) params.set('role', opts.role);
  if (opts.limit != null) params.set('limit', String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load users (${res.status})`);
  return res.json();
}

export async function getUser(id: number): Promise<AdminUserDetail> {
  const res = await apiFetch(`${BASE}/${id}`);
  if (res.status === 404) throw new Error('User not found');
  if (!res.ok) throw new Error(`Failed to load user (${res.status})`);
  return res.json();
}

export async function grantAiCredits(
  id: number,
  amount: number,
  note?: string
): Promise<{ userId: number; granted: number; aiAdsThisPeriod: number }> {
  const res = await apiFetch(`${BASE}/${id}/ai-credits`, {
    method: 'POST',
    body: JSON.stringify({ amount, note: note || null })
  });
  if (!res.ok) throw new Error((await res.text()) || `Failed to grant AI credits (${res.status})`);
  return res.json();
}
